import { useEffect } from 'react';

interface SEOData {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
}

const SITE_URL = 'https://fxcostguide.com';

export default function useSEO({ title, description, keywords, canonical }: SEOData) {
  useEffect(() => {
    // Title
    document.title = title;

    // Description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', description);
    }

    // Keywords
    if (keywords) {
      let metaKw = document.querySelector('meta[name="keywords"]');
      if (metaKw) {
        metaKw.setAttribute('content', keywords);
      }
    }

    // Canonical
    const canonicalUrl = canonical
      ? `${SITE_URL}${canonical}`
      : undefined;
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (canonicalUrl && linkCanonical) {
      linkCanonical.setAttribute('href', canonicalUrl);
    }

    // Open Graph
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl && canonicalUrl) ogUrl.setAttribute('content', canonicalUrl);

    // Twitter
    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', title);

    const twDesc = document.querySelector('meta[name="twitter:description"]');
    if (twDesc) twDesc.setAttribute('content', description);

    return () => {
      // Optionally reset to defaults on unmount — not needed for SPA navigation
    };
  }, [title, description, keywords, canonical]);
}